import { type SelectItem } from './types'
import { range } from '@terros/common'

const daysOfMonth = new Map<string, number>([
  ['January', 31],
  ['February', 29],
  ['March', 31],
  ['April', 30],
  ['May', 31],
  ['June', 30],
  ['July', 31],
  ['August', 31],
  ['September', 30],
  ['October', 31],
  ['November', 30],
  ['December', 31],
])

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const MONTHS: SelectItem[] = months.map((item, index) => ({
  label: `${item}`,
  value: `${index + 1}`,
}))

export function getMonthByKey(key?: number): string {
  if (!key || key < 1 || key > 12) {
    return ''
  }

  return months[key - 1]
}
